module.exports = __webpack_public_path__ + "img/Number=38.d5de3ccb.png";